export class MassUpdateEntity {
    ID: number;
    Name: string;
}

export default MassUpdateEntity;